'use client';

import { ThemeSwitcher } from "./theme-switcher";
import { LanguageSwitcher } from "./language-switcher";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { useBrowserAuthUser } from "@/utils/supabase/use-browser-auth-user";
import { Skeleton } from "./ui/skeleton";

export default function AppFooter() {
  const t = useTranslations();
  const { user, isLoading } = useBrowserAuthUser();

  if (isLoading) {
    return (
      <footer
        className="flex w-full items-center justify-center border-t text-center text-xs gap-8 py-1 md:py-4"
        aria-hidden="true"
      >
        <div className="flex items-center gap-4">
          <Skeleton className="h-3 w-24" />
          <Skeleton className="h-3 w-24" />
        </div>
        <div className="flex items-center gap-2">
          <Skeleton className="h-8 w-8 rounded-md" />
          <Skeleton className="h-8 w-8 rounded-md" />
        </div>
      </footer>
    );
  }

  const isLoggedIn = user && !user.is_anonymous;

  return (
    <div className={isLoggedIn ? "hidden md:block" : ""}>
      <footer className="flex w-full items-center justify-center border-t text-center text-xs gap-8 py-1 md:py-4">
        <div className="flex items-center gap-4">
          <Link href="/terms" className="hover:underline text-muted-foreground">
            {t('legal.terms.title')}
          </Link>
          <Link href="/privacy" className="hover:underline text-muted-foreground">
            {t('legal.privacy.title')}
          </Link>
        </div>
        <div className="flex items-center gap-2">
          <LanguageSwitcher className="max-h-[350px]" />
          <ThemeSwitcher />
        </div>
      </footer>
    </div>
  );
}
